import es_ES from 'antd/lib/locale/es_ES';
import saMessages from '../locales/es_ES.json';

const saLang = {
  messages: {
    ...saMessages,
  },
  antd: es_ES,
  locale: 'es',
};
export default saLang;
